import { RemoveType } from'../../Models/remove-type'

export const REMOVETYPES: RemoveType[] = [

]
